import { render, staticRenderFns } from "./OnlyDesktop.vue?vue&type=template&id=94fbfe0c"
import script from "./OnlyDesktop.vue?vue&type=script&lang=js"
export * from "./OnlyDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports